import { Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
	selector: 'app-svg-spinner',
	templateUrl: './svg-spinner.component.html',
	styleUrls: ['./svg-spinner.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgSpinnerComponent {}
